const _ = require("lodash");
const ImageCache = require("../util/ImageCache");
const ColorUtil = require("../util/ColorUtil");
const colors = ColorUtil.getDiagramColors();
const sharedColors = ColorUtil.getCurrentScheme();
const Numbers = require("../../../shared/Numbers");
const AssetsUtil = require("../util/AssetsUtil");

const Math2D = require("../util/Math2D");

const Helpers = require("./util/RenderHelpers");
// Alias a commonly used helper
const {scaleFont, getLineWidth, basicDrawNodeImage} = Helpers;

module.exports = {
	image: {
		draw(rc, x, y, node, measure) {
			const context = rc.context;
			const {isReflected, image} = node;
			const {pos, width, top} = measure;
			const rotation = (node.rotation * Math.PI) / 180 || 0;
			if (rotation || isReflected) {
				context.save();
				const imageX = pos[0] !== null ? pos[0] + x : x;
				const imageY = pos[1] !== null ? pos[1] + y : y;
				context.translate(imageX + width / 2 - pos[2] / 2, imageY - pos[3] / 2);
				context.translate(pos[2] / 2, pos[3] / 2);
				context.rotate(rotation);
				if (isReflected) {
					context.scale(-1, 1);
				}
				context.translate(-pos[2] / 2, -pos[3] / 2);
				context.drawImage(image, 0, 0, pos[2], pos[3]);
				context.restore();
			} else {
				context.save();
				context.beginPath();
				if (pos[0] !== null && pos[1] !== null) {
					context.drawImage(
						image,
						pos[0] + x,
						pos[1] + y - top,
						pos[2],
						pos[3]
					);
				} else {
					context.drawImage(image, x, y - top, pos[2], pos[3]);
				}
				context.restore();
			}
		},
		measure(rc, fontInfo, props, node) {
			let pos = node.position;
			// Calculating the image size and offsets and scaling by a factor
			// relative to the fontsize.
			pos = pos.map(x => (x !== null ? (x * fontInfo.size) / 20 : x));
			if (node.scale) {
				pos[2] *= node.scale;
				pos[3] *= node.scale;
			}
			if (node.rotation) {
				const rotation = (node.rotation * Math.PI) / 180;
				const width =
					Math.abs(pos[2] * Math.cos(rotation)) +
					Math.abs(pos[3] * Math.cos(Math.PI / 2 - rotation));
				const height =
					Math.abs(pos[2] * Math.sin(rotation)) +
					Math.abs(pos[3] * Math.sin(Math.PI / 2 - rotation));
				return {
					width: width,
					top: height / 2,
					bottom: height / 2,
					fontInfo,
					pos,
				};
			} else {
				return {
					width: pos[2],
					top: pos[3] / 2,
					bottom: pos[3] / 2,
					fontInfo,
					pos,
				};
			}
		},
	},
	coins: {
		draw(rc, x, y, node, measure) {
			const ctx = rc.context;
			ctx.save();
			const imgSrc = AssetsUtil.getCoinImage(node.imgType, node.position);
			const coinIC = ImageCache.src(imgSrc, true);
			const fontSize = measure.fontInfo.size;
			const symbolDim = measure.symbolDim;
			ctx.lineWidth = getLineWidth(rc, measure.fontInfo);

			const drawCoins = function(arrX, arrY, startX) {
				const adjustedX = _.map(startX, val => val + arrX);
				for (let i = 0; i < node.num; i++) {
					switch (node.imgType) {
						//I'm multiplying the dimensions by 4 to make the coins bigger and more readable
						case "s":
							ctx.drawImage(
								coinIC,
								adjustedX[i],
								arrY,
								symbolDim * 4,
								(symbolDim * 4 * 160) / 104
							);
							break;
						case "f":
						case "b":
							ctx.drawImage(
								coinIC,
								adjustedX[i],
								arrY,
								symbolDim * 4,
								symbolDim * 4
							);
							break;
						default:
							ctx.drawImage(
								coinIC,
								adjustedX[i],
								arrY,
								symbolDim * 4,
								(symbolDim * 4 * 60) / 98
							);
					}
				}
				return adjustedX;
			};

			drawCoins(x, y - measure.top - 0.125 * fontSize, measure.symbolStarts);
			ctx.restore();
		},
		measure(rc, fontInfo, props, node) {
			const symbolDim = fontInfo.size; //length and width for each symbol image
			const overlap = (1 / 5) * fontInfo.size; //overlap amount upon symbol change

			const getCoinLength = () => {
				let width = 0;
				const coinStarts = [];
				for (let i = 0; i < node.num; i++) {
					coinStarts.push(width);
					width += fontInfo.size * 5;
				}

				return {
					coinStarts,
					width,
				};
			};

			const coinMeasures = getCoinLength();
			const totalWidth = coinMeasures.width;
			let objHeight;
			switch (node.imgType) {
				case "s":
					objHeight = fontInfo.size * 4 * 1.5;
					break;
				case "f":
				case "b":
					objHeight = fontInfo.size * 4 * 1;
					break;
				default:
					objHeight = fontInfo.size * 3;
			}

			return {
				width: totalWidth,
				height: objHeight,
				top: objHeight / 2,
				bottom: objHeight / 2,
				fontInfo,
				symbolDim,
				overlap,
				symbolStarts: coinMeasures.coinStarts,
			};
		},
	},
	blocks: {
		draw(rc, x, y, node, measure) {
			const ctx = rc.context;
			ctx.save();
			const imgSrc = AssetsUtil.getBlockImage(node.imgType, node.color);
			const blockIC = ImageCache.src(imgSrc, true);
			const fontSize = measure.fontInfo.size;
			const symbolDim = measure.symbolDim;
			ctx.lineWidth = getLineWidth(rc, measure.fontInfo);

			const drawBlocks = function(arrX, arrY, startX, startY) {
				const adjustedX = _.map(startX, val => val + arrX);
				const adjustedY = _.map(startY, val => val + arrY);

				for (let i = 0; i < node.num; i++) {
					switch (node.imgType) {
						case 1:
							ctx.drawImage(
								blockIC,
								adjustedX[i],
								adjustedY[i],
								symbolDim * 1.38,
								(symbolDim * 1.38 * 110) / 115
							);
							break;
						case 5:
							ctx.drawImage(
								blockIC,
								adjustedX[i],
								adjustedY[i],
								symbolDim * 1.5,
								(symbolDim * 1.5 * 530) / 120
							);
							break;
						case 10:
							ctx.drawImage(
								blockIC,
								adjustedX[i],
								adjustedY[i],
								symbolDim * 1.5,
								(symbolDim * 1.5 * 804) / 115
							);
							break;
						case 100:
							ctx.drawImage(
								blockIC,
								adjustedX[i],
								adjustedY[i],
								(((symbolDim * 1.5 * 804) / 115) * 830) / 808,
								(symbolDim * 1.5 * 804) / 115
							);
							break;
					}
				}
				return adjustedX;
			};
			drawBlocks(
				x,
				y - measure.top + fontSize / 6,
				measure.xStarts,
				measure.yStarts
			);
			ctx.restore();
		},
		measure(rc, fontInfo, props, node) {
			const fontSize = fontInfo.size;

			let width = 0;
			let height = 0;
			const xStarts = [];
			const yStarts = [];

			for (let i = 0; i < node.num; i++) {
				xStarts.push(width);
				yStarts.push(height);
				switch (node.imgType) {
					case 1:
						// Get it correctly offset with the others...
						if (i === node.num - 1) height += fontSize * 0.9;
						// Then stack up with spacing in between.
						else height += fontSize * 1.42;
						break;
					case 5:
						if (i === node.num - 1) height += fontSize * 6.3;
						else height += fontSize * 7;
						break;
					case 10:
						if (i === node.num - 1) height += fontSize * 10.3;
						else height += fontSize * 11;
						break;
					case 100:
						if (i === node.num - 1) height -= fontSize * 0.2;
						else height += fontSize * 0.5;
						width += fontSize * 0.5;
						break;
				}
			}

			//This spaces them properly so they are all horizontally aligned
			switch (node.imgType) {
				case 1:
					width += fontSize * 2;
					height += fontSize * 0.245;
					break;
				case 5:
					width += fontSize * 2;
					height += fontSize * 0.115;
					break;
				case 10:
					width += fontSize * 2;
					break;
				case 100:
					width += (((fontSize * 1.5 * 804) / 115) * 830) / 808;
					height += (fontSize * 1.5 * 804) / 115;
					break;
			}

			return {
				width,
				height,
				top: height,
				bottom: 0,
				fontInfo,
				symbolDim: fontSize,
				xStarts,
				yStarts,
			};
		},
	},
	btenblocks: {
		draw(rc, x, y, node, measure) {
			const ctx = rc.context;
			ctx.save();
			const imgSrc = AssetsUtil.getBTenBlockImage(node.imgType, node.color);
			const blockIC = ImageCache.src(imgSrc, true);
			const fontSize = measure.fontInfo.size;
			const symbolDim = measure.symbolDim;
			ctx.lineWidth = getLineWidth(rc, measure.fontInfo);

			const drawBlocks = function(arrX, arrY, startX, startY) {
				const adjustedX = _.map(startX, val => val + arrX);
				const adjustedY = _.map(startY, val => val + arrY);

				for (let i = 0; i < node.num; i++) {
					switch (node.imgType) {
						case 1:
							ctx.drawImage(
								blockIC,
								adjustedX[i],
								adjustedY[i],
								symbolDim * 1.38,
								(symbolDim * 1.38 * 110) / 115
							);
							break;
						case 5:
							ctx.drawImage(
								blockIC,
								adjustedX[i],
								adjustedY[i],
								symbolDim * 1.5,
								(symbolDim * 1.5 * 530) / 120
							);
							break;
						case 10:
							ctx.drawImage(
								blockIC,
								adjustedX[i],
								adjustedY[i],
								symbolDim * 1.5,
								(symbolDim * 1.5 * 804) / 115
							);
							break;
						case 100:
							ctx.drawImage(
								blockIC,
								adjustedX[i],
								adjustedY[i],
								(((symbolDim * 1.5 * 804) / 115) * 830) / 808,
								(symbolDim * 1.5 * 804) / 115
							);
							break;
					}
				}
				return adjustedX;
			};
			drawBlocks(
				x,
				y - measure.top + fontSize / 6,
				measure.xStarts,
				measure.yStarts
			);
			ctx.restore();
		},
		measure(rc, fontInfo, props, node) {
			// these values are needed for 1 blocks
			const columnHeight = 5;
			const blockSeperation = 2;

			// values needed for all blocks
			const fontSize = fontInfo.size;
			let width = node.imgType === 100 ? (node.num - 1) * fontSize * 2 : 0;
			let height =
				node.imgType === 1
					? (5 - Math.min(columnHeight, node.num) + 0.59) *
					  fontSize *
					  blockSeperation
					: 0;
			const xStarts = [];
			const yStarts = [];

			for (let i = 0; i < node.num; i++) {
				xStarts.push(width);
				yStarts.push(height);
				switch (node.imgType) {
					case 1:
						// Get it correctly offset with the others...
						if (i === node.num - 1) height += fontSize * 0.9;
						// Then stack up with spacing in between.
						else height += fontSize * blockSeperation;

						// Move over a column if the current block is a multiple of the column height
						if (i % columnHeight === columnHeight - 1) {
							width +=
								i % (columnHeight * columnHeight) ===
								columnHeight * columnHeight - 1
									? fontSize * 3
									: fontSize * 2;
							if (node.num - i <= (node.num % columnHeight) + 1) {
								height -=
									(node.num % columnHeight) * fontSize * blockSeperation;
							} else {
								height -= columnHeight * fontSize * blockSeperation;
							}
						}
						break;
					case 10:
						if (i === node.num - 1) height += fontSize * 10.3;
						// Space them out horizontally
						width += fontSize * 2 + (i % 5 === 4 ? fontSize : 0);
						break;
					case 100:
						if (i === node.num - 1) height -= fontSize * 0.2;
						else height += fontSize * 1.8;
						width -= fontSize * 1.9;
						break;
				}
			}

			// reset the width or height when required
			if (node.imgType === 100) {
				width = node.num * fontSize * 2;
			} else if (node.imgType === 1) {
				height = fontSize * 10.3;
			}

			//This spaces them properly so they are all horizontally aligned
			switch (node.imgType) {
				case 1:
					width += fontSize * 3;
					break;
				case 10:
					width += fontSize;
					break;
				case 100:
					width += fontSize * 10.25;
					height += (fontSize * 1.5 * 804) / 115;
					break;
			}

			return {
				width,
				top: height / 2,
				bottom: height / 2 + 10,
				fontInfo,
				symbolDim: fontSize,
				xStarts,
				yStarts,
			};
		},
	},
	clock: {
		draw(rc, x, y, node, measure) {
			const context = rc.context;
			const {width, top, hour, minute, minuteOnly, hourOnly} = measure;
			const topY = y - top;
			context.save();
			const clockSize = width;
			//Drawing the clock face
			const clockFace = ImageCache.src(
				global.BASE_URL + "assets/images/problem-art/clock/face.svg",
				true
			);
			context.drawImage(clockFace, x, topY, clockSize, clockSize);
			if (_.isNumber(hour) && _.isNumber(minute)) {
				//Drawing the clock hands
				const handExtra = (clockSize * 1) / 12;
				if (!hourOnly) {
					const minuteHand = ImageCache.src(
						global.BASE_URL + "assets/images/problem-art/clock/minute-hand.svg",
						true
					);
					const minWidth = (clockSize * 1) / 14;
					const minHeight = (clockSize * 15) / 28;
					context.save();
					context.rotateAboutDeg(
						6 * minute,
						x + clockSize / 2,
						topY + clockSize / 2
					);
					context.drawImage(
						minuteHand,
						x + (clockSize - minWidth) / 2,
						topY + (clockSize / 2 + handExtra - minHeight),
						minWidth,
						minHeight
					);
					context.restore();
				}
				if (!minuteOnly) {
					const hourHand = ImageCache.src(
						global.BASE_URL + "assets/images/problem-art/clock/hour-hand.svg",
						true
					);
					const hourWidth = (clockSize * 1) / 18;
					const hourHeight = (clockSize * 10) / 28;
					context.save();
					context.rotateAboutDeg(
						30 * hour + 0.5 * minute,
						x + clockSize / 2,
						topY + clockSize / 2
					);
					context.drawImage(
						hourHand,
						x + (clockSize - hourWidth) / 2,
						topY + (clockSize / 2 + handExtra - hourHeight),
						hourWidth,
						hourHeight
					);
					context.restore();
				}
			}
			//Drawing the clock's center dot
			const clockCenter = ImageCache.src(
				global.BASE_URL + "assets/images/problem-art/clock/center.svg",
				true
			);
			const clockCenterSize = width * 0.08;
			context.drawImage(
				clockCenter,
				x + (clockSize - clockCenterSize) / 2,
				topY + (clockSize - clockCenterSize) / 2,
				clockCenterSize,
				clockCenterSize
			);

			context.restore();
		},
		measure(rc, fontInfo, props, node) {
			const clockSize = 150 * props.sizeScaleFactor;
			let hour = null;
			let minute = null;
			if (node.time) {
				const parsedTime = Numbers.stringToSimpleTime(node.time);
				if (parsedTime.error) {
					rc.pushError(parsedTime.error);
				} else {
					hour = parsedTime.hour;
					minute = parsedTime.minute;
				}
			}
			return {
				width: clockSize,
				top: clockSize / 2,
				bottom: clockSize / 2,
				hour,
				minute,
				minuteOnly: node.minuteOnly,
				hourOnly: node.hourOnly,
			};
		},
	},
	balanceScale: {
		draw(rc, x, y, node, measure) {
			const context = rc.context;
			const {
				width,
				top,
				bottom,
				scaleSizeMultiplier,
				unitSize,
				weightWidth,
				weightHeight,
			} = measure;
			context.save();

			//Drawing the main scale part
			const mainScale = ImageCache.src(
				global.BASE_URL + "assets/images/problem-art/scale/full.svg",
				true
			);
			context.drawImage(mainScale, x, y - top, width, top + bottom);

			//Drawing the weights
			const weight = ImageCache.src(
				global.BASE_URL + "assets/images/problem-art/scale/weight-large.svg",
				true
			);
			const critterY = y - top + measure.critterYPadding;
			const weightY = y - top + measure.weightYPadding;
			const labelY = weightY + weightHeight;
			//Drawing the weights on the left side
			let currX =
				x + 47.4 * unitSize * scaleSizeMultiplier - measure.leftWidth / 2;
			let i;
			for (i = 0; i < node.leftWeights.length; i++) {
				const m = measure.leftMeasures[i];
				if (m.isCritter) {
					const xPadding = (m.fullWidth - m.width) / 2;
					context.drawImage(
						ImageCache.src(m.src),
						currX + xPadding,
						critterY - m.height,
						m.width,
						m.height
					);
					currX += m.fullWidth;
				} else {
					context.drawImage(weight, currX, weightY, weightWidth, weightHeight);
					const lLabelY =
						labelY - ((3 / 5) * weightHeight - m.bottom - m.top) / 2;
					rc.drawNode(
						rc,
						currX + (weightWidth - m.width) / 2,
						lLabelY - m.bottom,
						node.leftWeights[i]
					);
					currX += weightWidth;
				}
			}
			//Drawing the weights on the right side
			currX =
				x + 177.9 * unitSize * scaleSizeMultiplier - measure.rightWidth / 2;
			for (i = 0; i < node.rightWeights.length; i++) {
				const m = measure.rightMeasures[i];
				if (m.isCritter) {
					const xPadding = (m.fullWidth - m.width) / 2;
					context.drawImage(
						ImageCache.src(m.src),
						currX + xPadding,
						critterY - m.height,
						m.width,
						m.height
					);
					currX += m.fullWidth;
				} else {
					context.drawImage(weight, currX, weightY, weightWidth, weightHeight);
					const rLabelY =
						labelY - ((2 / 3) * weightHeight - m.bottom - m.top) / 2;
					rc.drawNode(
						rc,
						currX + (weightWidth - m.width) / 2,
						rLabelY - m.bottom,
						node.rightWeights[i]
					);
					currX += weightWidth;
				}
			}

			context.restore();
		},
		measure(rc, fontInfo, props, node) {
			const critterInfo = Helpers.critterInfo;
			let scaleFactor = 1;
			//The small argument makes the scale & weights smaller to support more scales on the screen
			if (node.sizeModifier === "small") {
				scaleFactor = 0.65;
			}
			//The large argument only makes the scale itself larger (since the weights are large enough)
			const scaleSizeMultiplier = node.sizeModifier === "large" ? 1.25 : 1;
			const unitSize = props.sizeScaleFactor * 1.2 * scaleFactor;
			const width = 225 * unitSize * scaleSizeMultiplier;
			const height = 140 * unitSize * scaleSizeMultiplier;
			const weightWidth = 28 * unitSize;
			const weightHeight = (42 / 26) * weightWidth;
			const weightYPadding =
				52.5 * unitSize * scaleSizeMultiplier - weightHeight;
			const critterYPadding = 51 * unitSize * scaleSizeMultiplier;
			let i;
			const leftMeasures = [];
			let leftWidth = 0;
			const getCritterMeasure = name => {
				const ratio = critterInfo[name].ratio;
				const w = (ratio > 1.2 ? 32 : 34) * unitSize;
				return {
					isCritter: true,
					src:
						global.BASE_URL +
						"assets/images/problem-art/critters/" +
						critterInfo[name].img,
					width: w,
					height: w * ratio,
					fullWidth: 32 * unitSize,
				};
			};

			const labelFontInfo = scaleFont(fontInfo, scaleFactor);
			for (i = 0; i < node.leftWeights.length; i++) {
				if (node.leftWeights[i].isCritter) {
					leftMeasures[i] = getCritterMeasure(node.leftWeights[i].name);
					leftWidth += leftMeasures[i].fullWidth;
				} else {
					leftMeasures[i] = rc.measureNode(
						rc,
						labelFontInfo,
						props,
						node.leftWeights[i]
					);
					leftWidth += weightWidth;
				}
			}
			const rightMeasures = [];
			let rightWidth = 0;
			for (i = 0; i < node.rightWeights.length; i++) {
				if (node.rightWeights[i].isCritter) {
					rightMeasures[i] = getCritterMeasure(node.rightWeights[i].name);
					rightWidth += rightMeasures[i].fullWidth;
				} else {
					rightMeasures[i] = rc.measureNode(
						rc,
						labelFontInfo,
						props,
						node.rightWeights[i]
					);
					rightWidth += weightWidth;
				}
			}
			return {
				width: width,
				top: height / 2,
				bottom: height / 2,
				scaleSizeMultiplier,
				unitSize,
				leftMeasures,
				rightMeasures,
				leftWidth,
				rightWidth,
				weightWidth,
				weightHeight,
				weightYPadding,
				critterYPadding,
			};
		},
	},
	measuringCup: {
		draw(rc, x, y, node, measure) {
			const context = rc.context;
			const {top, cupWidth, cupHeight} = measure;
			const cup = ImageCache.src(
				global.BASE_URL + "assets/images/problem-art/measure/measuring-cup.svg",
				true
			);
			const fillX = x + (cupWidth * 1) / 40;
			const topY = y - top;
			const w = cupWidth;
			const h = cupHeight;
			const level16 = topY + (19.5 / 110) * h;
			const level0 = topY + (102 / 110) * h;
			const extraHeight = (6 / 110) * h;
			const fillLevel = node.fillLevel;
			context.save();
			if (node.restFillStyle) {
				context.fillStyle = colors[node.restFillStyle] || colors.blue;
				context.fillRect(
					fillX,
					level16,
					(w * 3) / 4,
					level0 - level16 + extraHeight
				);
			}
			if (fillLevel) {
				context.fillStyle =
					(node.fillStyle && colors[node.fillStyle]) || colors.blue;
				context.fillRect(
					fillX,
					level0 - (fillLevel / 16) * (level0 - level16),
					(w * 3) / 4,
					(fillLevel / 16) * (level0 - level16) + extraHeight
				);
			}
			context.drawImage(cup, x, topY, w, h);
			context.restore();
		},
		measure(rc, fontInfo, props, node) {
			// The size of the measuring cup depends on the font size, since we
			// want it to be affected by \bigger.
			const fontScaleFactor = fontInfo.size / props.baseFontSize;
			const cupWidth = 200 * props.sizeScaleFactor * fontScaleFactor;
			const cupHeight = (cupWidth * 110) / 135;
			return {
				width: cupWidth,
				top: cupHeight / 2,
				bottom: cupHeight / 2,
				cupWidth,
				cupHeight,
			};
		},
	},
	graduatedCylinder: {
		draw(rc, x, y, node, measure) {
			const context = rc.context;
			const {top, cylinderWidth, cylinderHeight} = measure;
			const cylinder = ImageCache.src(
				global.BASE_URL +
					"assets/images/problem-art/measure/graduated-cylinder.svg",
				true
			);
			const topY = y - top;
			const w = cylinderWidth;
			const h = cylinderHeight;
			const level50 = topY + (26.5 / 150) * h;
			const level0 = topY + (138.5 / 150) * h;
			const fillLevel = node.fillLevel;
			context.save();
			context.fillStyle =
				(node.fillStyle && colors[node.fillStyle]) || colors.blue;
			context.fillRect(
				x + w * 0.1,
				level0 - (fillLevel / 50) * (level0 - level50),
				w * 0.8,
				(fillLevel / 50) * (level0 - level50)
			);
			context.drawImage(cylinder, x, topY, w, h);
			context.restore();
		},
		measure(rc, fontInfo, props, node) {
			// The size of the graduated cylinder depends on the font size,
			// since we want it to be affected by \bigger.
			const fontScaleFactor = fontInfo.size / props.baseFontSize;
			const cylinderHeight = 200 * props.sizeScaleFactor * fontScaleFactor;
			const cylinderWidth = (cylinderHeight * 4) / 15;
			return {
				width: cylinderWidth,
				top: cylinderHeight / 2,
				bottom: cylinderHeight / 2,
				cylinderWidth,
				cylinderHeight,
			};
		},
	},
	thermometer: {
		draw(rc, x, y, node, measure) {
			const context = rc.context;
			const {top, w, h} = measure;
			const thermo = ImageCache.src(
				global.BASE_URL + "assets/images/problem-art/measure/thermometer.svg",
				true
			);
			const fillFaren = _.isInteger(node.fillFaren) ? node.fillFaren : -5;

			const topY = y - top;
			const level100 = topY + 0.055 * h;
			const level0 = topY + 0.861 * h;
			const degreeHeight = (level0 - level100) / 100;

			context.save();
			context.fillStyle =
				(node.fillStyle && colors[node.fillStyle]) || colors.blue;
			//Fill the bottom part up to -5deg F
			context.fillRect(
				x + w * 0.3,
				level0 + 5 * degreeHeight,
				w * 0.4,
				h - (level0 + 5.3 * degreeHeight - topY)
			);
			//Fill the rest of the way
			context.fillRect(
				x + w * 0.3,
				level0 - fillFaren * degreeHeight,
				w * 0.4,
				(fillFaren + 5.1) * degreeHeight
			);
			context.drawImage(thermo, x, topY, w, h);
			context.restore();
		},
		measure(rc, fontInfo, props, node) {
			const thermoHeight = 340 * props.sizeScaleFactor;
			const thermoWidth = (thermoHeight * 86) / 284;
			return {
				width: thermoWidth,
				top: thermoHeight / 2,
				bottom: thermoHeight / 2,
				w: thermoWidth,
				h: thermoHeight,
			};
		},
	},
	modibot: {
		draw(rc, x, y, node, measure) {
			basicDrawNodeImage(rc, x, y, node, measure);
			const {width, top, bottom, fit, childMeasure, midScaleFactor} = measure;

			const ctx = rc.context;
			ctx.save();

			const scaleX = fit.scale[0];
			const scaleY = fit.scale[1];

			ctx.scale(scaleX, scaleY);

			//Draw location from center of modibot
			const height = top + bottom;
			const relativeModibotWindowCentroid = [
				width * (1 / 2),
				height * midScaleFactor,
			];
			const childX =
				x +
				relativeModibotWindowCentroid[0] -
				(childMeasure.width * scaleX) / 2;
			const childY = y - top + relativeModibotWindowCentroid[1];

			// Change text color
			const modiTextColor = sharedColors.skyBlue;
			ctx.fillStyle = modiTextColor;

			rc.drawNode(
				rc,
				childX / scaleX,
				childY / scaleY,
				node.children[0],
				childMeasure
			);

			ctx.restore();
		},
		measure(rc, fontInfo, props, node) {
			const imgSrc = global.BASE_URL + "assets/images/problem-art/modibot.svg";
			const ratio = 125 / 115;
			const height = props.sizeScaleFactor * 80;
			const width = height / ratio;
			const botWindowWidth = 0.4 * width;

			const midScaleFactor = 4.8 / 8.25;
			const top = height * midScaleFactor;
			const bottom = height * (1 - midScaleFactor);

			//Measures math child
			const childMeasure = rc.measureNode(
				rc,
				fontInfo,
				props,
				node.children[0]
			);

			//modibot text window rect
			const modibotRect = [0, 0, botWindowWidth, botWindowWidth / 2];
			const textRect = [
				0,
				0,
				childMeasure.width,
				childMeasure.top + childMeasure.bottom,
			];

			//Scaling of child
			const fit = Math2D.fitInRect(textRect, modibotRect, {
				scaleDownOnly: true,
			});

			return {
				width: width,
				top: top,
				bottom: bottom,
				imgSrc,
				fontInfo,
				fit,
				childMeasure,
				midScaleFactor,
			};
		},
	},
};
